import { all, call, takeLatest, select, put } from 'redux-saga/effects';
import { camelcaseParser } from '@snapask/common-components/dist/utils/objCamelcaseParser';

import { apiFetchPremiumPage } from '@dragonfruit/services/apis';

import { getRegion as getRegionName } from '@dragonfruit/redux/locale';

import {
  FETCH_PREMIUM_PAGE,
  fetchPremiumPageSuccess,
  fetchPremiumPageFailure,
  transformPremiumPageData,
} from '@dragonfruit/redux/premiumPage';

import { PLAN_SECTION_LIST } from '@dragonfruit/constants/premiumPage';

export function* fetchPremiumPageFlow() {
  const regionName = yield select(getRegionName);

  try {
    const { sections: visibleSections, ...premiumSectionLists } = yield call(
      apiFetchPremiumPage,
      regionName
    );

    const validSectionList = new Set(PLAN_SECTION_LIST);

    /* only add section to valid list when:    
  	    1. section is in valid list.
  	    2. section has data (length isn't zero).
    */
    const {
      filteredSections,
      sectionLists: {
        tokenPacks = [],
        tokens = [],
        miniClasses = [],
        bundleBanners = [],
        webSubscriptionGroups: webSubscriptionGroupMapping = {},
        liveGroups = {},
      },
    } = visibleSections.reduce(
      (acc, sectionName) => {
        if (!validSectionList.has(sectionName)) {
          return acc;
        }

        const camelSectionName = camelcaseParser(sectionName);

        const sectionRawData = premiumSectionLists[camelSectionName];

        const isEmptyArray = target =>
          Array.isArray(target) && target.length === 0;
        const hasObjectProperty = target =>
          typeof target === 'object' && target.hasOwnProperty(target);

        const isValidDataFormat = target =>
          (!!target && hasObjectProperty(target)) || !isEmptyArray(target);

        if (!isValidDataFormat(sectionRawData)) return acc;

        const transformResult = transformPremiumPageData(
          sectionName,
          sectionRawData
        );

        if (!isValidDataFormat(transformResult)) return acc;

        acc.filteredSections.push(sectionName);
        acc.sectionLists[camelSectionName] = transformResult;
        return acc;
      },
      {
        sectionLists: {},
        filteredSections: [],
      }
    );

    //@TODO: add a transform function for structureDataList
    const tokenPackPlanList = tokenPacks.reduce(
      (acc, { plans }) => acc.concat(plans || []),
      []
    );

    const structureDataList = [
      ...tokenPackPlanList,
      ...tokens,
      ...webSubscriptionGroupMapping,
      ...miniClasses,
    ];

    yield put(
      fetchPremiumPageSuccess({
        structureDataList,
        sections: filteredSections,
        bundleBanners,
        tokenPacks,
        tokens,
        webSubscriptionGroupMapping,
        miniClasses,
        liveGroups,
      })
    );
  } catch (error) {
    yield put(fetchPremiumPageFailure(error));
  }
}

export default function*() {
  yield all([takeLatest(FETCH_PREMIUM_PAGE, fetchPremiumPageFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/premiumPage.js